/* eslint-disable react/forbid-prop-types */
import { faDownload } from '@fortawesome/pro-solid-svg-icons';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import CustomIcon from 'commons/Icon/CustomIcon';
import * as PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  downloadButton: {
    color: theme.palette.primary.main,
    // User negative margin to counteract padding and make a larger selection circle than the original div with padding
    padding: 7,
    margin: '-7px -7px -7px -7px'
  }
}
));

const DownloadIcon = ({ onClick, className, size = "small" }) => {
  const classes = useStyles();
  return (
    <IconButton
      className={`${className} ${classes.downloadButton}`}
      onClick={onClick}
      size={size}
    >
      <CustomIcon icon={faDownload} />
    </IconButton>
  );
};


DownloadIcon.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};

DownloadIcon.defaultProps = {
  className: ''
};

export default DownloadIcon;